import React  from 'react';
import Container from '../component/container/Container'
import {sideBarListItems} from '../component/Sidebar/SideBarItems'
import Panel from "../component/panel/Panel";
import './SuperAdminStyle.css'

export const SuperAdmin = () => {
    return (
        <section className="main-division">
            <Panel sideBarListItems={sideBarListItems}/>
            <Container/>
        </section>
    )
}
